import { useState } from "react";
import styled from "@emotion/styled";
import { Button, TextField, Typography, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useAuth } from "src/Common/context/AuthContext";

export const Login = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!username || !password) return;
    setSubmitting(true);
    try {
      await login(username, password);
    } catch (error: any) {
      const status = error?.response?.status;
      const message =
        status === 401
          ? "Invalid credentials"
          : error?.response?.data?.message ||
            error?.message ||
            "Login failed";
      toast(message, {
        theme: "dark",
        type: "error",
        autoClose: 6000,
        pauseOnFocusLoss: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Typography variant="h6" style={{ color: "white" }}>
          Crypto App
        </Typography>
        <TextField
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          fullWidth
          disabled={submitting}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          fullWidth
          disabled={submitting}
        />
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          disabled={submitting || !username || !password}
          fullWidth
        >
          {submitting ? <CircularProgress size={24} /> : "Log in"}
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.theme.palette.background.default};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  flex: 1;
`;

const Form = styled.form`
  width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;
